"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  &:first-child {\n    margin-top: 1em;\n  }\n  &:last-child {\n    margin-bottom: 1em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var P = _styledComponents.default.p(_templateObject());

var Span = _styledComponents.default.span(_templateObject2());

var Credits = /*#__PURE__*/function (_Component) {
  _inherits(Credits, _Component);

  var _super = _createSuper(Credits);

  function Credits() {
    _classCallCheck(this, Credits);

    return _super.apply(this, arguments);
  }

  _createClass(Credits, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          _this$props$credits = _this$props.credits,
          credits = _this$props$credits === void 0 ? {} : _this$props$credits,
          reviewLabel = _this$props.reviewLabel,
          authorLabel = _this$props.authorLabel,
          currentLabel = _this$props.currentLabel,
          className = _this$props.className,
          otherAttributes = _objectWithoutProperties(_this$props, ["asOfDate", "credits", "reviewLabel", "authorLabel", "currentLabel", "className"]);

      var primaryReviewers = [];
      var secondaryReviewers = [];
      credits.primaryReviewers && credits.primaryReviewers.forEach(function (reviewer) {
        primaryReviewers.push(reviewer.name);
      });
      credits.secondaryReviewers && credits.secondaryReviewers.forEach(function (reviewer) {
        secondaryReviewers.push(reviewer.name);
      });
      var creditsClass = 'hw-structured-content-credits';
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: className ? className + ' ' + creditsClass : creditsClass
      }, otherAttributes), asOfDate ? /*#__PURE__*/_react.default.createElement(P, null, /*#__PURE__*/_react.default.createElement(Span, null, currentLabel, ":"), " ", asOfDate) : '', credits.author && credits.author.name ? /*#__PURE__*/_react.default.createElement(P, null, /*#__PURE__*/_react.default.createElement(Span, null, authorLabel, ":"), " ", credits.author.name) : '', primaryReviewers.length ? /*#__PURE__*/_react.default.createElement(P, null, /*#__PURE__*/_react.default.createElement(Span, null, reviewLabel, ":"), " ", primaryReviewers.join('; '), secondaryReviewers.length ? ' & ' + secondaryReviewers.join('; ') : '') : '');
    }
  }]);

  return Credits;
}(_react.Component);

Credits.defaultProps = {
  currentLabel: 'Current as of',
  authorLabel: 'Author',
  reviewLabel: 'Medical Review',
  className: null
};
Credits.propTypes = {
  currentLabel: _propTypes.default.string,
  authorLabel: _propTypes.default.string,
  reviewLabel: _propTypes.default.string,
  asOfDate: _propTypes.default.string,
  className: _propTypes.default.string,
  credits: _propTypes.default.shape({
    author: _propTypes.default.shape({
      name: _propTypes.default.string
    }),
    primaryReviewers: _propTypes.default.array,
    secondaryReviewers: _propTypes.default.array
  })
};
var _default = Credits;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/Credits/index.js